import { setTag } from "service/mapper";
import { apiPut } from "../baseApi";

export const update = async (id, data) => {
  try {
    const response = await apiPut("_tag", id, data);
    return { ...response, data: setTag(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
